import React from "react";
import "./MySelf.css";

const MySelf = () => {
  return (
    <div className="my-self" data-aos="fade-up">
      <h1>Riaz Ahmed</h1>
      <h2>Front-end Developer & Web UI/UX Designer</h2>
    </div>
  );
};

export default MySelf;
